import styled from "styled-components";

export const Container = styled.div`
	max-width: 1024px;
`;
export const Label = styled.span`
	color: #6b6b6b;
	text-align: center;
	font-size: 16px;
	font-style: normal;
	font-weight: 500;
	line-height: 20px; /* 125% */
	letter-spacing: 1.28px;
`;
